import { render, staticRenderFns } from "./SubHeader.vue?vue&type=template&id=0392bf4a&scoped=true"
import script from "./SubHeader.vue?vue&type=script&lang=ts"
export * from "./SubHeader.vue?vue&type=script&lang=ts"
import style0 from "./SubHeader.vue?vue&type=style&index=0&id=0392bf4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0392bf4a",
  null
  
)

export default component.exports